



































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ANAMNESA_ITEMS,
  PEMFIS_FIELDS,
  PENUNJANG_FIELDS
} from "@/constants/catatanPraAnestesiOptions";

@Component
export default class CatatanPraSedasiDetail extends Vue {
  @Prop({ required: true }) item!: any;

  anamnesaItems = ANAMNESA_ITEMS;
  pemfisFields = PEMFIS_FIELDS;
  penunjangFields = PENUNJANG_FIELDS;

  get viewContent() {
    return this.item?.content || {};
  }

  get viewNyeri() {
    return this.viewContent.nyeri || {};
  }

  get viewKeadaan() {
    return this.viewContent.keadaan_umum || {};
  }

  get viewJalanNafas() {
    return (this.viewContent.pemeriksaan_fisik || {}).jalan_nafas || {};
  }

  get viewPenunjang() {
    return this.viewContent.penunjang || {};
  }

  get viewRekomendasi() {
    return this.viewContent.rekomendasi || {};
  }

  get isAsaEmergency() {
    return (
      this.viewContent.asa_emergency === true ||
      this.viewContent.asa_klasifikasi === "E"
    );
  }

  get viewAsaLabel() {
    const kelas = this.viewContent.asa_klasifikasi;
    const parts = [
      kelas && kelas !== "E" ? kelas : "",
      this.isAsaEmergency ? "E" : ""
    ];
    return parts.filter(Boolean).join(" ") || "-";
  }

  get mallampatiColor() {
    const score = this.viewContent.pemeriksaan_fisik?.mallampati;
    if (score === 1) return "green lighten-4";
    if (score === 2) return "light-green lighten-4";
    if (score === 3) return "orange lighten-4";
    if (score === 4) return "red lighten-4";
    return "grey lighten-3";
  }

  getAnamnesaVal(key: string) {
    return this.viewContent.anamnesa ? this.viewContent.anamnesa[key] : null;
  }

  getPemfisVal(key: string) {
    return this.viewContent.pemeriksaan_fisik
      ? this.viewContent.pemeriksaan_fisik[key]
      : null;
  }
}
